import React, { FC } from 'react';

import { BUTTON_TYPES, EvButton, EvSelectNew, OptionType } from '@evinced-private/ui-common';

interface IPerformanceOverTimeSelectGroupV2 {
	selectedTimeFrame: OptionType[];
	onTimeFrameSelect: (value: OptionType[]) => void;
	TIME_FRAME_OPTIONS: OptionType[];
	selectedViews: OptionType[];
	onMultiViewSelect: (values: OptionType[]) => void;
	viewsOptions: OptionType[];
	isApplyButtonDisabled: boolean;
	onApplyView: () => void;
}

export const PerformanceOverTimeSelectGroupV2: FC<IPerformanceOverTimeSelectGroupV2> = ({
	selectedTimeFrame,
	onTimeFrameSelect,
	TIME_FRAME_OPTIONS,
	selectedViews,
	onMultiViewSelect,
	viewsOptions,
	isApplyButtonDisabled,
	onApplyView
}) => {
	return (
		<div className="select-group-v2">
			<EvSelectNew
				options={TIME_FRAME_OPTIONS}
				selectedValue={selectedTimeFrame}
				onSelectChange={onTimeFrameSelect}
				placeholder="Select time frame"
				label="Time frame"
				id="performance-over-time-select-time-frame"
			/>
			<EvSelectNew
				options={viewsOptions}
				selectedValue={selectedViews}
				onSelectChange={onMultiViewSelect}
				placeholder="Select views"
				label="Selected views"
				shouldShowHelpText={false}
				isMultiple={true}
				maxSelectedItems={5}
				listboxWidth="100%"
				id="performance-over-time-select-views"
			/>

			<EvButton disabled={isApplyButtonDisabled} type={BUTTON_TYPES.PRIMARY} onClick={onApplyView}>
				Apply
			</EvButton>
		</div>
	);
};
